const getters = {
  isAdminUser: (state) => {
    const { groups = [] } = state.user;
    const foundAdminGroup = groups.find((item) => ["super_admin", "admin"].includes(item.code));

    return !!foundAdminGroup;
  },
  isRh(state) {
    return state.user.email.includes('rh')
  }
};

export default getters;
